export default __webpack_public_path__ + "static/media/d23a2eff6c572771ad6bfca3b3cbf833.svg";